import { Attribute } from './attribute';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { LAttribute } from './lattribute';
import { CommonEnums } from 'src/app/shared/common.enums';
import { LAttributesUtil } from 'src/app/shared/grids/lattributes/lattributes.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';
import { Rlup_Inst } from './rlup_inst';

export class Rollup {
    rlup_Inst: Rlup_Inst;

    lAttributes: Array<LAttribute>;
    attributes: Array<Attribute>;
    outWindowAttributes: Array<Attribute>;

    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    is_In_SubFlow: string;

    sel_Run_PropertyType_Cd: string;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    prop_Tab_Change_Ind: string;
    gAttr_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    type: Array<string>;
    functions: Array<string>;

    constructor() {
        this.setDefault()
    }

    setDefault(): void {
        this.rlup_Inst = new Rlup_Inst();

        this.lAttributes = new Array<LAttribute>();
        this.attributes = new Array<Attribute>();
        this.outWindowAttributes = new Array<Attribute>();

        this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_VAL_NO;

        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.prop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gAttr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;

        this.type = new Array<string>();
        this.functions = new Array<string>();
    }

    static parse(rollupTmp: Rollup): Rollup {
        let rollup: Rollup = new Rollup();
        rollup.copyFrom(rollupTmp);
        return rollup;
    }

    copy(): Rollup {
        let rollupTmp: Rollup = new Rollup();

        rollupTmp.rlup_Inst = this.rlup_Inst.copy();

        rollupTmp.lAttributes = LAttributesUtil.getInstance().copy(this.lAttributes);
        let attributesUtil: AttributesUtil = AttributesUtil.getInstance();
        rollupTmp.attributes = attributesUtil.copy(this.attributes);
        rollupTmp.outWindowAttributes = attributesUtil.copy(this.outWindowAttributes);

        rollupTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        rollupTmp.ref_Id = this.ref_Id;
        rollupTmp.ref_Cd = this.ref_Cd;
        rollupTmp.fldr_Id = this.fldr_Id;
        rollupTmp.is_In_SubFlow = this.is_In_SubFlow;

        rollupTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        rollupTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        rollupTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        rollupTmp.change_Ind = this.change_Ind;
        rollupTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        rollupTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;
        rollupTmp.gAttr_Tab_Change_Ind = this.gAttr_Tab_Change_Ind;
        rollupTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        rollupTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        rollupTmp.error_Cd = this.error_Cd;
        rollupTmp.error_Msg = this.error_Msg;

        rollupTmp.type  =this.type;
        rollupTmp.functions = this.functions;

        return rollupTmp;
    }

    copyFrom(rollupTmp: Rollup): void {
        this.rlup_Inst.copyFrom(rollupTmp.rlup_Inst);

        LAttributesUtil.getInstance().copyFrom(this.lAttributes, rollupTmp.lAttributes);
        let attributesUtil: AttributesUtil = AttributesUtil.getInstance();
        attributesUtil.copyFrom(this.attributes, rollupTmp.attributes);
        attributesUtil.copyFrom(this.outWindowAttributes, rollupTmp.outWindowAttributes);

        this.nativeDbTyp_Id = rollupTmp.nativeDbTyp_Id;
        this.ref_Id = rollupTmp.ref_Id;
        this.ref_Cd = rollupTmp.ref_Cd;
        this.fldr_Id = rollupTmp.fldr_Id;
        this.is_In_SubFlow = rollupTmp.is_In_SubFlow;

        this.sel_Run_PropertyType_Cd = rollupTmp.sel_Run_PropertyType_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, rollupTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, rollupTmp.runPropertyTypes);

        this.change_Ind = rollupTmp.change_Ind;
        this.gen_Tab_Change_Ind = rollupTmp.gen_Tab_Change_Ind;
        this.prop_Tab_Change_Ind = rollupTmp.prop_Tab_Change_Ind;
        this.gAttr_Tab_Change_Ind = rollupTmp.gAttr_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = rollupTmp.attr_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = rollupTmp.rProp_Tab_Change_Ind;

        this.error_Cd = rollupTmp.error_Cd;
        this.error_Msg = rollupTmp.error_Msg;

        this.type = rollupTmp.type;
        this.functions = rollupTmp.functions;
    }

    compare(rollupTmp: Rollup): string {
        let diffString: string = this.rlup_Inst.compare(rollupTmp.rlup_Inst);
        if (diffString != '') return diffString;

        diffString = this.toBaseCompare(rollupTmp);
        if (diffString != '') return diffString;

        diffString = LAttributesUtil.getInstance().compare(this.lAttributes, rollupTmp.lAttributes);
        if (diffString != '') return diffString;

        diffString = AttributesUtil.getInstance().compare(this.attributes, rollupTmp.attributes);
        if (diffString != '') return diffString;

        diffString = AttributesUtil.getInstance().compare(this.outWindowAttributes, rollupTmp.outWindowAttributes);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, rollupTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, rollupTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(rollupTmp: Rollup): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = rollupTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toBaseString(): string {
        return ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
            ", fldr_Id=" + this.fldr_Id + ", is_In_SubFlow=" + this.is_In_SubFlow;
    }

    toString(isNotCompare: boolean = true): string {
        let attributesUtil: AttributesUtil = AttributesUtil.getInstance();
        let str: string = "Rollup [rlup_Inst=" + this.rlup_Inst.toString() + this.toBaseString() +
            ", lAttributes=" + LAttributesUtil.getInstance().toString(this.lAttributes) +
            ", attributes=" + attributesUtil.toString(this.attributes) +
            ", outWindowAttributes=" + attributesUtil.toString(this.outWindowAttributes) +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);

        if (isNotCompare) {
            str += ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind +
                ", gAttr_Tab_Change_Ind=" + this.gAttr_Tab_Change_Ind + ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind +
                ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind + ", change_Ind=" + this.change_Ind +
                ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd;
        }

        str += "]";
        return str;
    }
}